import React from "react";
import PropTypes from "prop-types";

const StoriesAndSignalsIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill={props.fill}
      style={props.style}
      viewBox="0 0 2000 2000"
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1312.000000,2001.000000 
	C876.166687,2001.000000 440.833344,2000.994263 5.500021,2001.092896 
	C1.750949,2001.093750 0.906737,2000.249023 0.907281,1996.500000 
	C1.003694,1332.833374 1.003694,669.166687 0.907281,5.500014 
	C0.906737,1.751003 1.751000,0.906735 5.500013,0.907280 
	C669.166687,1.003704 1332.833374,1.003704 1996.500000,0.907280 
	C2000.249023,0.906735 2001.093262,1.751001 2001.092651,5.500013 
	C2000.996338,669.166687 2000.996216,1332.833374 2001.092651,1996.500000 
	C2001.093140,2000.249023 2000.249146,2001.095093 1996.500000,2001.093384 
	C1768.500000,2000.989258 1540.500000,2001.000000 1312.000000,2001.000000 
z"
      />
      <path
        fill="#29235C"
        opacity="1.000000"
        stroke="none"
        d="
M795.250122,1046.691284 
	C790.585815,1032.259521 786.063477,1018.202515 781.502930,1004.157898 
	C779.417847,997.736694 777.856384,996.726135 771.365967,997.851624 
	C725.529480,1005.800110 679.701172,1013.795593 633.865540,1021.749084 
	C619.621643,1024.220703 605.370178,1026.650635 591.106262,1029.002808 
	C588.006897,1029.513794 585.587830,1030.769287 583.454285,1033.150269 
	C538.784973,1083.000854 494.059540,1132.801270 449.345154,1182.611572 
	C437.554474,1195.746094 425.740265,1208.859619 413.984283,1222.025146 
	C409.653534,1226.875122 409.696533,1228.942261 413.732239,1234.168945 
	C441.307953,1269.881714 468.878235,1305.598755 496.440887,1341.321533 
	C501.743195,1348.193604 505.065247,1348.141724 510.284515,1340.938232 
	C528.839905,1315.328613 547.370911,1289.701172 565.912964,1264.081909 
	C567.259888,1262.220825 568.621582,1260.370483 570.618347,1257.635986 
	C584.183594,1351.314331 597.603394,1443.987793 611.196838,1537.860840 
	C605.935120,1533.636475 601.420105,1530.128174 597.030212,1526.469727 
	C526.371765,1467.584961 470.217438,1397.129150 428.967529,1314.921753 
	C399.486847,1256.169434 379.468750,1194.303467 368.831604,1129.383423 
	C361.890320,1087.019897 358.724060,1044.399658 360.428741,1001.543518 
	C366.454559,850.054077 417.830566,715.725464 515.912720,600.130737 
	C606.302002,493.602356 719.936584,423.231781 855.341309,388.447021 
	C896.515320,377.869629 938.433350,371.654205 980.937256,369.815094 
	C1145.705933,362.685669 1292.814453,410.399719 1422.421631,512.248230 
	C1430.927368,518.932312 1438.938232,526.243530 1447.358643,533.040649 
	C1449.831665,535.036865 1449.697266,536.750366 1448.582886,539.301086 
	C1443.065308,551.930237 1437.681152,564.617615 1432.272217,577.294006 
	C1430.045288,582.512939 1430.878174,585.801758 1434.760864,587.413574 
	C1438.637451,589.022827 1441.524902,587.346252 1443.751831,582.110596 
	C1448.559448,570.806885 1453.401978,559.517212 1458.086182,548.162354 
	C1459.235107,545.377319 1459.850220,544.421753 1462.609375,547.037292 
	C1505.142212,587.356018 1541.863403,632.374023 1572.491455,682.348389 
	C1612.738159,748.017212 1640.477051,818.638367 1655.719238,894.102051 
	C1663.574707,932.993652 1667.650879,972.316406 1668.286011,1012.042847 
	C1670.025879,1120.879272 1646.140259,1223.735107 1596.721436,1320.630859 
	C1567.956177,1377.031494 1531.509521,1428.057983 1487.790161,1473.879028 
	C1422.649414,1542.151489 1346.398193,1594.144165 1259.017456,1629.716431 
	C1211.106323,1649.220825 1161.496704,1662.584839 1110.296265,1670.182861 
	C1068.651611,1676.362793 1026.824097,1678.372437 984.809326,1676.613281 
	C955.859985,1675.401367 927.104736,1672.181519 898.589111,1666.967163 
	C896.975098,1666.672119 895.405457,1666.134399 893.830872,1665.293091 
	C917.875305,1665.782104 941.923401,1666.141724 965.962158,1666.828125 
	C974.726685,1667.078369 976.417358,1666.098877 978.116089,1657.626465 
	C993.993347,1578.438477 1009.906738,1499.257446 1025.777588,1420.068115 
	C1033.223267,1382.916992 1040.648438,1345.761353 1047.925049,1308.576904 
	C1048.602783,1305.113892 1049.392334,1304.560425 1052.621826,1306.116943 
	C1073.561523,1316.209595 1094.593872,1326.109985 1115.588013,1336.089844 
	C1123.048828,1339.636475 1125.396118,1338.696411 1128.176880,1330.953247 
	C1131.693359,1321.161621 1131.676636,1321.212036 1141.454224,1324.441650 
	C1189.045654,1340.161255 1236.658569,1355.815674 1284.222778,1371.616699 
	C1288.291504,1372.968262 1291.359375,1372.541992 1294.739746,1369.794312 
	C1327.305176,1343.323608 1359.955933,1316.957520 1392.655640,1290.652466 
	C1395.843872,1288.087646 1397.380737,1285.106812 1398.172485,1281.105103 
	C1410.163208,1220.504639 1422.299805,1159.932983 1434.418091,1099.357788 
	C1440.253418,1070.189087 1446.267700,1041.055054 1451.887451,1011.844910 
	C1453.623535,1002.820862 1458.158447,995.095703 1461.905518,987.011475 
	C1481.315552,945.136475 1500.859741,903.323242 1520.536011,861.572754 
	C1522.761475,856.850891 1522.415283,853.403564 1519.046021,849.379272 
	C1505.148682,832.780579 1491.592773,815.896301 1477.720703,799.275940 
	C1475.613159,796.750977 1475.309692,794.682922 1476.248047,791.689697 
	C1485.781860,761.282227 1495.199097,730.838196 1504.636475,700.400513 
	C1506.845703,693.275269 1505.701416,691.077454 1498.640259,689.100830 
	C1448.116699,674.957947 1397.588501,660.831543 1347.057617,646.714844 
	C1340.505615,644.884460 1338.479858,645.981873 1336.221191,652.481689 
	C1301.572388,752.190552 1266.927490,851.900696 1232.285034,951.611755 
	C1229.669189,959.140564 1230.776367,961.232605 1238.603394,963.343811 
	C1275.314941,973.246155 1312.020996,983.169067 1348.765747,992.946777 
	C1352.126343,993.841003 1353.154907,994.762756 1351.930664,998.422180 
	C1328.114136,1069.607056 1304.400879,1140.826538 1280.806519,1212.085327 
	C1279.477051,1216.100342 1278.286255,1216.299561 1274.770508,1214.300903 
	C1247.028076,1198.530640 1219.197266,1182.914917 1191.298096,1167.423584 
	C1188.215698,1165.712036 1187.373169,1164.318604 1188.781250,1160.918945 
	C1191.253906,1154.949097 1193.166504,1148.746460 1195.298584,1142.636230 
	C1197.512085,1136.292725 1196.830688,1134.456299 1191.096558,1131.334839 
	C1129.369995,1097.733276 1067.640137,1064.137695 1005.914917,1030.533447 
	C987.089355,1020.284546 968.274841,1010.015381 949.456665,999.752991 
	C941.842834,995.600891 939.876953,996.196594 936.013306,1004.138855 
	C905.578674,1066.701172 875.165649,1129.274048 844.741821,1191.841675 
	C844.454041,1192.433472 844.108215,1192.996948 843.267883,1194.517578 
	C827.140564,1144.865479 811.258484,1095.968262 795.250122,1046.691284 
z"
      />
      <path
        fill="#29235C"
        opacity="1.000000"
        stroke="none"
        d="
M601.046082,1381.943115 
	C594.312073,1335.081543 587.622742,1288.660400 580.920959,1242.240845 
	C580.500977,1239.331421 579.665955,1236.662109 576.312805,1235.841064 
	C572.428894,1234.889893 570.154419,1236.959106 568.041748,1239.888550 
	C547.401367,1268.509277 526.637329,1297.041016 506.076111,1325.718384 
	C503.652161,1329.098999 502.643494,1329.265747 500.031525,1325.852173 
	C475.949951,1294.379639 451.789215,1262.965942 427.356781,1231.765869 
	C424.034851,1227.523926 427.063385,1225.985107 429.047882,1223.772095 
	C469.290039,1178.897339 509.575562,1134.061523 549.852295,1089.217773 
	C563.203491,1074.352661 576.602234,1059.529907 589.857300,1044.579590 
	C591.980408,1042.184937 594.318298,1040.940674 597.413879,1040.409424 
	C632.816467,1034.331909 668.206421,1028.180298 703.596252,1022.028564 
	C723.911377,1018.497192 744.230896,1014.988220 764.522705,1011.326782 
	C768.493225,1010.610413 770.731018,1010.558228 772.325623,1015.533630 
	C792.988831,1080.004395 813.981262,1144.369629 834.892395,1208.760864 
	C835.200256,1209.708740 835.591003,1210.633911 835.839722,1211.596313 
	C836.599365,1214.536621 837.963074,1216.864746 841.343262,1217.197144 
	C845.106873,1217.567261 847.083008,1215.398804 848.578979,1212.284912 
	C854.763855,1199.410645 861.018616,1186.570068 867.265869,1173.725952 
	C892.978394,1120.861816 918.743286,1068.023193 944.316284,1015.091797 
	C946.114502,1011.369751 947.598267,1012.792297 949.843384,1014.016724 
	C1008.777954,1046.158081 1067.730835,1078.265869 1126.675415,1110.389160 
	C1144.040283,1119.852539 1161.342163,1129.433472 1178.789429,1138.742188 
	C1181.834595,1140.366699 1182.705200,1141.586548 1181.445435,1145.095337 
	C1160.645996,1203.030884 1139.958862,1261.007080 1119.443115,1319.043579 
	C1117.994873,1323.140869 1116.586914,1322.967163 1113.274170,1321.371826 
	C1092.031372,1311.141602 1070.699097,1301.096802 1049.391846,1291.000366 
	C1042.400024,1287.687378 1039.359375,1289.215820 1037.836792,1296.826538 
	C1016.500122,1403.481201 995.171997,1510.137573 973.833862,1616.791870 
	C971.582581,1628.044678 969.144226,1639.262329 967.092896,1650.551025 
	C966.549438,1653.541626 965.393188,1654.312622 962.543091,1654.264526 
	C927.404541,1653.669434 892.263916,1653.199707 857.124634,1652.644043 
	C839.976624,1652.372925 822.831055,1651.945923 805.683167,1651.666870 
	C763.064209,1650.973633 720.444275,1650.339844 677.825317,1649.647217 
	C666.342834,1649.460693 654.863037,1649.040649 643.380554,1648.970703 
	C640.397095,1648.952393 639.435120,1647.985107 639.021423,1645.087769 
	C632.839233,1601.787964 626.514221,1558.508667 620.268799,1515.217773 
	C614.142212,1472.750977 608.069031,1430.276367 601.966064,1387.806274 
	C601.705627,1385.994141 601.382019,1384.191162 601.046082,1381.943115 
z"
      />
      <path
        fill="#2A245C"
        opacity="1.000000"
        stroke="none"
        d="
M1333.824951,862.774719 
	C1339.948975,846.577209 1345.961304,830.754211 1351.903320,814.904785 
	C1352.693604,812.796814 1353.449097,811.372131 1356.113037,810.799866 
	C1387.616455,804.033081 1419.081665,797.087891 1450.541016,790.117676 
	C1453.251831,789.517151 1454.709595,790.552490 1456.362915,792.586548 
	C1472.954712,812.998779 1489.585693,833.380676 1506.435913,853.578979 
	C1508.704102,856.297913 1508.411865,858.197876 1507.122559,860.949707 
	C1485.854980,906.343079 1464.609863,951.747131 1443.482056,997.205627 
	C1438.871826,1007.124878 1438.200562,1018.102051 1436.065918,1028.647827 
	C1423.335815,1091.535034 1410.827759,1154.467407 1398.265381,1217.388672 
	C1394.426392,1236.617554 1390.641602,1255.857300 1386.855835,1275.096802 
	C1386.236816,1278.242432 1385.143921,1280.846558 1382.420166,1283.031372 
	C1351.768188,1307.618164 1321.205566,1332.316528 1290.697266,1357.081421 
	C1288.364624,1358.974854 1286.470093,1359.406250 1283.548340,1358.434692 
	C1235.666870,1342.513306 1187.752563,1326.690430 1139.800049,1310.984375 
	C1136.512939,1309.907715 1135.992432,1308.774048 1137.146484,1305.570068 
	C1152.105347,1264.039307 1166.926758,1222.458984 1181.788574,1180.893188 
	C1182.229858,1179.658936 1182.733887,1178.446899 1183.274170,1177.055908 
	C1213.939331,1194.265015 1244.364014,1211.339478 1274.789551,1228.411865 
	C1275.949341,1229.062622 1277.106079,1229.721558 1278.288086,1230.330200 
	C1283.851685,1233.193726 1286.976196,1232.005249 1288.956665,1226.083252 
	C1295.690796,1205.946045 1302.336304,1185.779053 1309.065796,1165.640137 
	C1328.360352,1107.897949 1347.682617,1050.165161 1366.983276,992.424988 
	C1368.560547,987.706543 1369.994873,982.939697 1371.609741,978.234497 
	C1373.104248,973.879761 1372.120239,970.731934 1368.175903,967.972107 
	C1349.906982,955.189148 1331.828003,942.134888 1313.560913,929.349304 
	C1310.698242,927.345703 1309.678101,925.835022 1311.104614,922.205505 
	C1318.814697,902.588562 1326.196411,882.842529 1333.824951,862.774719 
z"
      />
      <path
        fill="#2A245D"
        opacity="1.000000"
        stroke="none"
        d="
M1416.977661,679.067871 
	C1440.874390,685.744873 1464.367554,692.360657 1487.869873,698.943542 
	C1489.920532,699.517883 1492.062500,699.491699 1491.007446,702.861145 
	C1482.575928,729.787537 1474.276733,756.755371 1465.931396,783.728821 
	C1465.435425,783.561462 1465.003418,783.551819 1464.894165,783.359131 
	C1461.138794,776.735718 1455.831543,776.211426 1448.773682,777.828918 
	C1415.741211,785.398865 1382.607178,792.530090 1349.469971,799.633850 
	C1345.569580,800.469910 1343.388916,802.293396 1342.014038,805.937988 
	C1327.133545,845.385315 1312.208374,884.816101 1297.156616,924.198303 
	C1295.309692,929.030518 1296.117554,932.208496 1300.462158,935.237122 
	C1318.892578,948.084839 1337.153198,961.175903 1355.468140,974.189026 
	C1357.463135,975.606506 1359.678101,976.627625 1358.051392,980.057739 
	C1356.330811,983.686157 1354.191528,981.551880 1352.256836,981.038574 
	C1318.235840,972.011047 1284.254028,962.834045 1250.196777,953.946594 
	C1245.800903,952.799500 1245.434814,951.328369 1246.830811,947.324585 
	C1279.724609,852.987366 1312.508545,758.611694 1345.185669,664.199158 
	C1346.515991,660.355286 1347.808594,659.584534 1351.846558,660.766357 
	C1373.359253,667.062378 1394.987915,672.961548 1416.977661,679.067871 
z"
      />
      <path
        fill="#FCFCFD"
        opacity="1.000000"
        stroke="none"
        d="
M947.957397,887.906860 
	C940.794495,889.037109 934.073914,890.184998 927.320251,891.084717 
	C924.782043,891.422852 924.109619,892.532288 924.060730,894.985535 
	C923.722839,911.959045 923.266663,928.930420 922.783630,945.900635 
	C922.357666,960.867615 921.868530,975.832886 921.363708,990.797424 
	C921.173706,996.432739 919.595215,998.039734 913.720276,998.356873 
	C888.306213,999.728577 862.888000,1001.025085 837.472961,1002.379395 
	C828.337708,1002.866150 819.210022,1003.501282 810.073059,1003.947388 
	C804.684814,1004.210449 801.980652,1001.364990 802.250793,996.103455 
	C803.573303,970.353638 804.878601,944.602905 806.196167,918.852905 
	C807.700806,889.447083 809.165466,860.039001 810.795166,830.640076 
	C810.951538,827.818848 810.237915,826.038269 808.088928,824.247498 
	C793.378784,811.989868 778.804260,799.569580 764.100464,787.304260 
	C761.534546,785.163818 760.027588,782.983826 759.765747,779.417664 
	C756.902405,740.419189 753.866638,701.433350 750.833923,662.447449 
	C747.310913,617.157715 743.743652,571.871460 740.197815,526.583435 
	C739.899170,522.768616 739.591492,518.954285 739.336426,515.136475 
	C739.074219,511.212219 741.299988,509.223999 744.667664,507.687103 
	C782.420715,490.457581 820.132935,473.138519 857.854797,455.840698 
	C873.396423,448.713928 888.982239,441.680481 904.443359,434.383057 
	C908.570679,432.435059 911.751526,432.816284 915.435059,435.497375 
	C959.429443,467.518005 1003.485474,499.454315 1047.620605,531.280457 
	C1051.761353,534.266418 1052.797485,537.590210 1051.843994,542.399536 
	C1038.824219,608.072449 1025.912354,673.766785 1012.958984,739.452881 
	C1003.990051,784.933350 994.954590,830.400757 986.079468,875.899475 
	C985.138489,880.723083 982.344055,882.399353 977.916077,883.049561 
	C968.051819,884.498047 958.227295,886.217163 947.957397,887.906860 
z"
      />
      <path
        fill="#FCFBFD"
        opacity="1.000000"
        stroke="none"
        d="
M714.114868,601.156128 
	C709.523193,609.736816 710.044312,617.883667 712.445190,626.856262 
	C721.976074,662.474121 730.749146,698.294189 739.970459,733.996094 
	C741.119934,738.446655 740.045349,741.448425 736.849426,744.603394 
	C698.315002,782.642822 659.877014,820.780029 621.458130,858.936340 
	C619.015320,861.362610 616.557617,862.958496 613.076050,861.440247 
	C609.394897,859.834961 609.427734,856.703491 609.811768,853.406433 
	C612.679749,828.786194 615.194092,804.118896 618.489014,779.556152 
	C621.462158,757.391785 622.773621,735.346497 620.481140,712.979858 
	C618.260376,691.311707 617.417725,669.501770 615.995544,647.752441 
	C615.257385,636.463867 614.708740,625.160706 613.794495,613.886841 
	C613.474060,609.935669 614.603577,607.358215 617.938171,605.117615 
	C654.251221,580.717712 690.499695,556.221497 726.726685,531.693848 
	C729.759583,529.640320 732.726440,528.562988 735.834045,531.056519 
	C738.811096,533.445312 738.238586,536.502625 737.044128,539.681580 
	C729.397461,560.033508 721.817566,580.410461 714.114868,601.156128 
z"
      />
      <path
        fill="#FBFBFC"
        opacity="1.000000"
        stroke="none"
        d="
M1276.270752,525.742920 
	C1270.960815,512.803894 1265.830322,500.205750 1260.694580,487.609741 
	C1260.506836,487.149231 1260.240234,486.720551 1260.056641,486.258667 
	C1257.662598,480.238098 1258.399414,476.511963 1262.255737,475.088806 
	C1266.342041,473.580750 1269.086426,475.454651 1271.578369,481.522766 
	C1287.269531,519.730652 1302.952271,557.942017 1318.636597,596.152649 
	C1318.952148,596.921326 1319.280762,597.686157 1319.557007,598.469055 
	C1320.838989,602.101379 1320.173340,605.326904 1316.461182,606.771973 
	C1312.737183,608.221497 1309.631104,606.974426 1308.000977,602.971619 
	C1303.306885,591.444397 1298.582275,579.929565 1293.855225,568.415771 
	C1288.060791,554.302185 1282.251953,540.194458 1276.270752,525.742920 
z"
      />
      <path
        fill="#FBFBFC"
        opacity="1.000000"
        stroke="none"
        d="
M1178.163818,650.892700 
	C1197.811890,661.425781 1217.108032,671.837402 1236.423340,682.213440 
	C1239.363159,683.792603 1241.805664,685.559937 1241.359985,689.451233 
	C1240.917236,693.317932 1237.645752,695.795227 1233.948120,694.500244 
	C1230.995239,693.466187 1228.220093,691.878784 1225.445557,690.388977 
	C1198.518921,675.930603 1171.609009,661.441223 1144.695312,646.958984 
	C1144.109741,646.643921 1143.526733,646.322205 1142.957031,645.979431 
	C1139.656616,643.993713 1138.162231,641.151794 1140.015259,637.587952 
	C1141.951538,633.863770 1145.174561,633.112610 1148.890503,635.112976 
	C1158.543457,640.309204 1168.176880,645.541626 1178.163818,650.892700 
z"
      />
      <path
        fill="#29235C"
        opacity="1.000000"
        stroke="none"
        d="
M752.141846,518.594543 
	C770.127869,509.863464 787.993103,501.463257 805.928650,493.216003 
	C838.805603,478.098267 871.742859,463.111359 904.594421,447.938721 
	C907.666748,446.519806 909.733521,446.679291 912.539429,448.724915 
	C953.551331,478.622925 994.642639,508.412384 1035.818604,538.084045 
	C1038.778809,540.217163 1039.231323,542.190369 1038.563110,545.543274 
	C1028.950195,593.773254 1019.480896,642.031799 1009.965820,690.281311 
	C1001.093567,735.271057 992.206482,780.257935 983.328491,825.246582 
	C980.561218,839.269897 977.665527,853.270386 975.153687,867.339417 
	C974.637024,870.233398 973.470215,871.313477 970.874573,871.730469 
	C947.728394,875.448608 924.583008,879.172607 901.453186,882.990417 
	C898.762573,883.434509 896.784912,882.861084 894.677002,881.081116 
	C854.860352,847.459412 814.987244,813.904541 775.096252,780.370972 
	C773.104858,778.696960 771.904602,777.014526 771.698975,774.185791 
	C769.926331,749.806213 767.940796,725.442200 766.037231,701.072083 
	C763.822876,672.720825 761.612427,644.369263 759.427734,616.015747 
	C757.613281,592.466736 755.837463,568.914734 754.046875,545.363892 
	C753.378662,536.574341 752.717224,527.784302 752.141846,518.594543 
z"
      />
      <path
        fill="#2A245D"
        opacity="1.000000"
        stroke="none"
        d="
M821.043091,869.002197 
	C821.585449,858.241821 822.097412,847.965820 822.663330,836.607300 
	C830.750977,843.416138 838.054321,849.566406 845.359497,855.714600 
	C859.631531,867.726074 874.034302,879.587280 888.097534,891.838196 
	C892.297974,895.497314 896.260925,896.595947 901.687134,895.423279 
	C911.908325,893.214417 911.948242,893.493408 911.658386,903.685181 
	C910.977112,927.641357 910.315674,951.598145 909.649597,975.554749 
	C909.342285,986.610596 909.336975,986.422791 898.341614,986.947449 
	C872.583923,988.176758 846.837280,989.634888 821.082581,990.929443 
	C814.819092,991.244324 814.793457,991.117371 815.129089,984.643494 
	C817.041626,947.755737 818.965271,910.868530 820.878662,873.980835 
	C820.956299,872.484497 820.969482,870.984680 821.043091,869.002197 
z"
      />
      <path
        fill="#2A245D"
        opacity="1.000000"
        stroke="none"
        d="
M717.609436,552.980225 
	C719.202026,554.578735 717.687195,555.894470 717.171265,557.290466 
	C710.902405,574.253601 704.606628,591.207031 698.240540,608.133789 
	C696.967285,611.519226 696.756165,614.705688 697.682617,618.313538 
	C707.386169,656.102173 716.917480,693.935059 726.527588,731.747803 
	C727.157349,734.225769 727.553223,736.210327 725.284729,738.450134 
	C691.972290,771.341187 658.777161,804.350891 625.546326,837.324524 
	C625.332214,837.536926 625.008240,837.638733 624.004028,838.203796 
	C624.802246,830.785950 625.487671,823.837097 626.307373,816.904175 
	C629.100342,793.283447 632.562988,769.718994 634.489685,746.028931 
	C635.397461,734.867737 633.442322,723.466064 632.692993,712.179443 
	C631.183044,689.437622 629.609924,666.699951 628.063904,643.960510 
	C627.477417,635.333923 627.002869,626.697632 626.240356,618.086670 
	C626.019409,615.591431 626.684998,614.184265 628.761780,612.789795 
	C658.310486,592.948486 687.800049,573.019165 717.609436,552.980225 
z"
      />
      <path
        fill="#2A245D"
        opacity="1.000000"
        stroke="none"
        d="
M717.963257,552.945679 
	C718.214966,552.826965 718.448730,552.677185 718.682556,552.527466 
	C718.538574,552.761536 718.394653,552.995667 718.082825,553.039551 
	C717.914978,552.849426 717.945312,552.914551 717.963257,552.945679 
z"
      />
    </svg>
  );
};

StoriesAndSignalsIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

StoriesAndSignalsIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default StoriesAndSignalsIllustration;
